
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M16.5 6.74999V17.33C16.5 19.42 14.97 21.28 12.89 21.48C10.5 21.71 8.5 19.84 8.5 17.5V5.13999C8.5 3.82999 9.44 2.63999 10.74 2.50999C12.24 2.35999 13.5 3.52999 13.5 4.99999V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6.74999C11.5 6.33999 11.16 5.99999 10.75 5.99999C10.34 5.99999 10 6.33999 10 6.74999V15.36C10 16.67 10.94 17.86 12.24 17.99C13.74 18.14 15 16.97 15 15.5V5.16999C15 3.07999 13.47 1.21999 11.39 1.01999C9.01 0.789993 7 2.65999 7 4.99999V17.27C7 20.14 9.1 22.71 11.96 22.98C15.25 23.28 18 20.72 18 17.5V6.74999C18 6.33999 17.66 5.99999 17.25 5.99999C16.84 5.99999 16.5 6.33999 16.5 6.74999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-attach-file`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAttachFile

    ```js
    <b-new-b-icon-attach-file />
    ```
</docs>


